<div class="page-header">
  <div class="grid-container">
  Technical Check debug logs for {{changeRequestID}}
  </div>
</div>
<div class="grid-container">
<div class="content content-with-elevation">
  <div class="grid-x tech-log"
       *ngFor="let log of techCheckLogs">
    <span style="white-space: pre-wrap">{{log}}</span>
  </div>
</div>
</div>

